/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to master-doc-list.reducer.js
 */
export const PREFIX = 'MASTER_DOC_LIST';

export const TYPES = {
    DOCUMENT_SAMPLE_DOC_CHANGED:        `${PREFIX}_DOCUMENT_SAMPLE_DOC_CHANGED`,
    REQUIREMENT_DETAILS_REFRESH:        `${PREFIX}_REQUIREMENT_DETAILS_REFRESH`,
    DOC_DETAILS_REFRESH:                `${PREFIX}_DOC_DETAILS_REFRESH`,
    SELECT_REQUIREMENTS_SELECT_CASCADE: `${PREFIX}_SELECT_REQUIREMENTS_SELECT_CASCADE`,
    RESET_REQUIREMENTS_SELECT_CASCADE:  `${PREFIX}_RESET_REQUIREMENTS_SELECT_CASCADE`,
    SCHEME_DETAILS_REFRESH:             `${PREFIX}_SCHEME_DETAILS_REFRESH`,
};
